/**
 * Available cell types for blueprint, combining vertices and edges.
 * @constant {Object.<string, Symbol>}
 */
export const CELL_TYPES = {
  // vertices
  shape: Symbol('shape'),
  text: Symbol('text'),
  image: Symbol('image'),

  // edges
  line: Symbol('line'),
  orthogonal: Symbol('orthogonal'),
};

/**
 * Available shape types for blueprint. The names map to the fabric class
 * name for a given shape. Used for comparison and dynamic selection.
 * @constant {Object.<BPShapeKey, string>}
 */
export const SHAPE_TYPES = {
  square: 'Rect',
  circle: 'Circle',
  triangle: 'Triangle',
  diamond: 'Polygon',
};

/**
 * Default blueprint text, used to check whether the value has changed when displaying.
 * @type {string}
 */
export const DEFAULT_BLUEPRINT_TEXT = 'Double click\nto edit text';
